import { defineStore } from 'pinia';
import { eGameSort, type TSortFiltersByPage } from '~/types/gamesSortAndFilters';

export const useGamesFiltersStore = defineStore('gamesFilters', {
  state: () => ({
    filtersByPage: {} as TSortFiltersByPage,
  }),
  actions: {
    setFilters(page: string, filters: string[]) {
      if (!this.filtersByPage[page]) {
        this.filtersByPage[page] = { sort: eGameSort.Default, filters };
      }
      this.filtersByPage[page].filters = filters;
    },
    setSort(page: string, sort: eGameSort) {
      if (!this.filtersByPage[page]) {
        this.filtersByPage[page] = { sort, filters: [] };
      }
      this.filtersByPage[page].sort = sort;
    },
    getConfig(page: string) {
      return this.filtersByPage[page];
    },
    clearFilters(page: string) {
      if (this.filtersByPage[page]) {
        this.filtersByPage[page].filters = [];
        this.filtersByPage[page].sort = eGameSort.Default;
      }
    },
    clearAllFilters() {
      this.filtersByPage = {};
    },
  },
});
